import React from 'react';

import './styles.css';


export const Header = () => {
  return (
    <header className="header row">
    </header>
  )
};
